import { memo } from 'react'

import { BackButton, SlideUp } from 'common-components'
import TtsVelocityOptions from '../Components/Options'
import * as Styled from './styled'

interface IProps {
  selectedValue: number | string
  handleValueClick: (value: number) => void
  closeVelocityContent: () => void
  isOpen: boolean
  onClose: () => void
}
const MobileTtsVelocity: React.FC<IProps> = (props: IProps) => {
  const {
    selectedValue,
    handleValueClick,
    closeVelocityContent,
    isOpen,
    onClose
  } = props
  return (
    <SlideUp isOpen={isOpen} onClose={onClose}>
      <Styled.MobileTtsVelocityContentWrapper>
        <BackButton onClick={closeVelocityContent} />
        <Styled.MobileTtsVelocityOptionsWrapper>
          <TtsVelocityOptions
            selectedValue={selectedValue}
            handleValueClick={handleValueClick}
          />
        </Styled.MobileTtsVelocityOptionsWrapper>
      </Styled.MobileTtsVelocityContentWrapper>
    </SlideUp>
  )
}

export default memo(MobileTtsVelocity)
